<template>
  <QToolbar class="calculator-header">
    <QToolbarTitle class="flex container">
      <div class="header-logo full-width">
        <a :href="logoRoute">
          <img v-if="organisationLogo" class="brand-logo" :src="organisationLogo" alt="Scoreboard" style="max-height: 40px" />
        </a>
      </div>
      <div class="full-width">
        <img v-if="fleetPartnerLogo && !isMMBA" class="brand-logo pull-right" :src="fleetPartnerLogo" alt="Scoreboard" />
      </div>
    </QToolbarTitle>
  </QToolbar>
</template>

<script>
import { QToolbar, QToolbarTitle } from 'quasar';
import { mapGetters } from 'vuex';
export default {
  name: 'CalculatorHeader',
  data() {
    return {
      organisationLogoPlaceholder: `${process.env.BASE_URL}assets/logos/fleetpartners_logo.svg`,
      fleetPartnerLogoPlaceholder: `${process.env.BASE_URL}assets/logos/fleetpartners_logo.svg`
    };
  },
  computed: {
    ...mapGetters({
      orgProfile: 'theme/getScoreboard',
      whitelabel: 'theme/getWhitelabel',
      calculator: 'theme/getCalculator'
    }),
    organisationLogo() {
      return this.calculator?.headerLogo || 'https://assets.eclipx.xyz/sme/dev/301902b6-6667-445e-8dfe-1276c4870582';
    },
    fleetPartnerLogo() {
      return this.orgProfile?.primaryLogoRight ? this.orgProfile.primaryLogoRight : null;
    },
    isMMBA() {
      return this.whitelabel?.abn === '53007870395' || this.whitelabel?.introducer?.abn === '53007870395';
    },
    logoRoute() {
      if (this.calculator?.headerLogoLink) return this.calculator?.headerLogoLink;

      const DEFAULT_LOGO_ROUTE = '/calculator';
      if (!document.referrer) {
        return DEFAULT_LOGO_ROUTE;
      }

      const { host: currentHost } = window.location;
      const { host: previousHost, href: previousURL } = new URL(document.referrer);

      if (previousHost !== currentHost) {
        return previousURL;
      }

      return DEFAULT_LOGO_ROUTE;
    }
  },

  components: { QToolbar, QToolbarTitle }
};
</script>

<style lang="sass" scoped>
.calculator-header
  .container
    max-width: 1440px
    .header-logo
      padding: 20px 10px

@media (max-width: 768px)
  .calculator-header .container .header-logo
    padding: 15px 0
</style>
